<template>
  <div>
    <el-button v-if="editAble" type="text" @click="showAddExpress" style="margin-bottom: 15px;margin-left: 30px">添加</el-button>
    <div class="totalAmount">合计：{{amountFormat(totalAmount)}} 元</div>
    <el-table :data="expressList">
      <el-table-column v-if="!editAble" label="交付单号" min-width="100" align="center" prop="deliveryOrderNum">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="$jump.deliver(scope.row.deliveryOrderId, '_blank')">{{scope.row.deliveryOrderNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="发货日期" min-width="100" align="center" prop="expressDate"/>
      <el-table-column label="收货人" min-width="100" align="center" prop="receiverName"/>
      <el-table-column label="联系电话" min-width="100" align="center" prop="receiverMobile"/>
      <el-table-column label="物流公司" min-width="100" align="center" prop="logisticsCompanyName"/>
      <el-table-column label="物流单号" min-width="100" align="center" prop="logisticsNum"/>
      <el-table-column label="物流费用（元）" min-width="100" align="center" prop="logisticsFee"/>
      <el-table-column label="备注" min-width="100" align="center" prop="expressRemark"/>
      <el-table-column v-if="editAble" label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="deleteItem(scope.row)">移除</el-button>
          <el-button type="text"  @click="editItem(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <AddExpressDialog ref="addExpressDialogRef" @success="addExpressCallBack"/>
  </div>
</template>

<script>
import {expressList, deleteExpress} from "@/api/crm/order";
import {mapState} from 'vuex'
import AddExpressDialog from "./addExpressDialog.vue"
import { amountFormat } from '@/utils/index'

export default {
  name: "expressList",
  props: {
    deliveryOrderId: {
      type: Number,
      default: null,
    },
    contractId: {
      type: Number,
      default: null,
    },
    editAble: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    AddExpressDialog
  },
  data() {
    return {
      amountFormat,
      totalAmount: null,
      expressList: [],
      originalExpressList: [],
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  created() {
    this.queryList()
  },
  methods: {
    showAddExpress() {
      this.$refs.addExpressDialogRef.open(this.deliveryOrderId)
    },
    queryList() {
      if (!this.deliveryOrderId && !this.contractId) {
        return
      }
      expressList({
        deliveryOrderId: this.deliveryOrderId,
        contractId: this.contractId
      }).then(response => {
        this.expressList = response.data.expressList
        this.totalAmount = response.data.totalAmount
        if (this.expressList && this.expressList.length >= 1) {
          this.deliveryOrderId = this.expressList[0].deliveryOrderId
        }
      }).catch(error => {
      })
    },
    deleteItem(row) {
      this.$confirm('确认移除该条数据吗？').then(() => {
        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        deleteExpress(row.id).then(response => {
          this.queryList()
          this.$emit('success')
          this.msgSuccess("操作成功");
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {
      });
    },
    editItem(row) {
      this.$refs.addExpressDialogRef.open(row.deliveryOrderId, row)
    },
    addExpressCallBack() {
      this.queryList()
      this.$emit('success')
    }
  }
};
</script>
